import { QUERY_KEYS } from "@cnx/common";
import { useQuery } from "@tanstack/react-query";
import UserService from "services/UserService";

export const useUserAvatarBase64 = (avatarId?: string | null) => {
  const { data: avatarBase64 } = useQuery({
    queryKey: [QUERY_KEYS.USERS, { avatarId }],
    queryFn: () => {
      if (!avatarId) return null;
      return UserService.getUserAvatar(avatarId);
    },
    enabled: !!avatarId,
  });

  return avatarBase64;
};
